const offerStatus = Object.freeze({
  pending: 'pending',
  accepted: 'accepted',
  rejected: 'rejected',
  waiting: 'waiting',
});

export default offerStatus;
